module.exports = __webpack_public_path__ + "static/media/fieldMappings.7f447007.svg";